<template>
  <div v-if="$Can('view_dashboard_report')">
    <b-card class="position-relative">
      <div v-if="isLoading" class="loading-overlay d-flex align-items-center justify-content-center">
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
          <div class="mt-1">Loading dashboard…</div>
        </div>
      </div>
      <b-card-header>
        <b-card-title class="d-flex justify-content-between align-items-center w-100">
        
          <div class="d-flex align-items-center">
            Dashboard Summary
        <b-dropdown id="dropdown-time-clinic-report" text="Time Report" variant="link" class="ml-2">
          <template #button-content>
            <span>{{ selectedReport }}</span>
            <i class="fa fa-chevron-down ml-2"></i>
          </template>
          <b-dropdown-item @click="selectReport('Time Report')">Time Report</b-dropdown-item>
          <b-dropdown-item @click="selectReport('Clinic Report')">Clinic Report</b-dropdown-item>
        </b-dropdown>

        </div>
       
        <div>
          <b-button class="ml-5" variant="success" @click="downloadPDF"
              >Download PDF</b-button
            >
        </div>
      </b-card-title>
    </b-card-header>
      <div
        class="mb-2 text-center d-flex justify-content-center align-items-center"
      >
      <b-row class="mb-1">
          <b-col cols="12" lg="4">
            <treeselect
              v-model="selectedDepartments"
              @input="handleInput"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="departmentOptions"
            />
          </b-col>

          <b-col cols="12" lg="5">
            <treeselect
              v-model="selectedTasks"
              @input="handleInput"
              value-consists-of="LEAF_PRIORITY"
              :limit="3"
              :multiple="true"
              :options="taskOptions"
            />
          </b-col>

          <b-col cols="12" lg="3">
            <flat-pickr
              v-model="selectedDates"
              class="form-control bg-white w-100"
              :config="datePickerConfig"
            />
          </b-col>

          <b-col cols="12" lg="12" class="mt-50">
            <b-button class="mr-1" variant="info" @click="selectThisWeek"
              >This Week</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisMonth"
              >This Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectLastMonth"
              >Last Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectNextMonth"
              >Next Month</b-button
            >
            <b-button class="mr-1" variant="info" @click="selectThisYear"
              >This Year</b-button
            >
          
          </b-col>
        </b-row>
        </div>
      <b-row class="d-flex align-items-center justify-content-center">
      <b-col cols="12" md="4" lg="4" class="mb-3 mb-md-0">
        <b-card
          class="text-center"
          style="background-color: #FFA726; color: white; border-radius: 15px; padding: 20px;"
        >
          <h4>Tasks</h4>
          <span style="font-size: 2rem;">{{ summary.activeTasks }}</span>
        </b-card>
      </b-col>

      <b-col cols="12" md="4" lg="4" class="mb-3 mb-md-0">
        <b-card
          class="text-center"
          style="background-color: #42A5F5; color: white; border-radius: 15px; padding: 20px;"
        >
          <h4>Departments</h4>
          <span style="font-size: 2rem;">{{ summary.activeDepartments.length }}</span>
        </b-card>
      </b-col>

      <b-col cols="12" md="4" lg="4" class="mb-3 mb-md-0">
        <b-card
          class="text-center"
          style="background-color: #66BB6A; color: white; border-radius: 15px; padding: 20px;"
        >
          <h4>Sites</h4>
          <span style="font-size: 2rem;">{{ summary.activeSites.length }}</span>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mt-3 d-flex align-items-center justify-content-center">
      <b-col cols="12" md="6" lg="4" class="mb-3 mb-md-0">
        <b-card>
          <h4 class="text-center mb-1"> {{ selectedReport == 'Time Report' ? 'Department Time Report' : 'Department Clinic Report' }}</h4>
          <canvas id="tasksByDepartmentChart" width="700" height="500"></canvas>
        </b-card>
      </b-col>
      <!-- <b-col cols="12" md="6" lg="4" class="mb-3 mb-md-0">
        <b-card>
          <h4 class="text-center mb-1">Tasks by Site</h4>
          <canvas id="tasksBySiteChart" width="400" height="400"></canvas>
        </b-card>
      </b-col> -->
      <b-col cols="12" md="6" lg="4" class="mb-3 mb-md-0">
        <b-card>
          <h4 class="text-center mb-1">{{ selectedReport == 'Time Report' ? 'Task Time Report' : 'Clinic Task Report' }}</h4>
          <canvas id="taskCountsChart" width="700" height="500"></canvas>
        </b-card>
      </b-col>
    </b-row>



      <b-row>
        <b-col>
          <div class="d-flex justify-content-between flex-wrap mb-2">
            <div class="mr-2 mb-1">
              <b-form-checkbox switch v-model="isReportSummary" @input="toggleSummary"
                >Summary</b-form-checkbox
              >
            </div>
            <div class="ml-auto mb-1">
              <b-button variant="success" @click="taskDataExport"
                >Export .xlsx</b-button
              >
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <TaskTable v-if="!isReportSummary" :taskTable="taskTable" />
        <TaskSummaryReportTable v-else :taskReportTable="parsedSummaryReportTable" />
      </b-row>
    </b-card>
  </div>

  <div v-else class="text-center mt-5 text-danger">
    No Permission
  </div>
</template>

<script>
import axios from "axios";
import reportStoreModule from "./reportStoreModule";
import store from "@/store";
import { onUnmounted } from "@vue/composition-api";
import Chart from "chart.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TaskTable from "./TaskTable.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TaskSummaryReportTable from "./TaskSummaryReportTable.vue";

export default {
  setup() {
    const DASHBOARD_APP_STORE_MODULE_NAME = "dashboard";
    if (!store.hasModule(DASHBOARD_APP_STORE_MODULE_NAME))
      store.registerModule(DASHBOARD_APP_STORE_MODULE_NAME, reportStoreModule);
    onUnmounted(() => {
      if (store.hasModule(DASHBOARD_APP_STORE_MODULE_NAME))
        store.unregisterModule(DASHBOARD_APP_STORE_MODULE_NAME);
    });
  },

  components: {
    flatPickr,
    TaskTable,
    Treeselect,
    TaskSummaryReportTable,
  },

  data() {
    return {
      selectedReport: 'Clinic Report',
      selectedDepartments: [],
  selectedTasks: [],
      departmentOptions: [],
  taskOptions: [],

    isReportSummary:false,
    parsedSummaryReportTable:[],

      taskTable: [],
      selectedDates: [],
      datePickerConfig: {
        dateFormat: "d/m/Y",
        mode: "range",
        locale: {
          firstDayOfWeek: 1, // Monday
        },
        onChange: this.onDateChange,
      },
      summary: {
        activeTasks: 0,
        taskCounts: [],
        activeDepartments: [],
        activeSites: [],
      },
      charts: {
        tasksByDepartmentChart: null,
        tasksBySiteChart: null,
        taskCountsChart: null,
      },
      colorPalette: [
        "#f06a6a",
        "#ec8d71",
        "#f1bd6c",
        "#f8df72",
        "#b3df97",
        "#83c9a9",
        "#4ecbc4",
        "#9ee7e3",
        "#4573d2",
        "#a69ff3",
        "#cd95ea",
        "#f9aaef",
        "#f26fb2",
        "#fc979a",
        "#ff0000",
        "#ff8000",
        "#ffff00",
        "#80ff00",
        "#00ff00",
        "#00ff80",
        "#00ffff",
        "#0080ff",
        "#0000ff",
        "#8000ff",
        "#ff00ff",
        "#ff0080",
        "#ff0040",
        "#ff00bf",
        "#D2042D",
        "#800020",
      ],
      isLoading: true,
    };
  },

  created() {
    if (this.$Can("view_dashboard_report")) this.setDefaultDates();
    this.fetchDepartments();
  },

  methods: {

    selectReport(report) {
      this.selectedReport = report;
      // Handle the selection logic here
      console.log('Selected report:', report);
      this.renderCharts();
    },

    handleInput() {
      if (!this.selectedDates || this.selectedDates.length === 0) {
        return;
      }

      let dates = [];

      if (
        typeof this.selectedDates === "string" &&
        this.selectedDates.includes(" to ")
      ) {
        const [startDateStr, endDateStr] = this.selectedDates.split(" to ");

        const startDate = this.parseDate(startDateStr);
        const endDate = this.parseDate(endDateStr);

        dates = [startDate, endDate];
      } else if (Array.isArray(this.selectedDates)) {
        dates = this.selectedDates.map((date) => new Date(date));
      }

      // Tarihleri ISO formatına çevir
      const formattedDates = dates.map(
        (date) => date.toISOString().split("T")[0]
      );

      this.fetchDashboardSummary(formattedDates);
    },
    parseDate(dateStr) {
      const [day, month, year] = dateStr.split("/").map(Number);
      return new Date(year, month - 1, day);
    },

    setDefaultDates() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      const firstDay = new Date(now.setDate(firstDayOfWeek));
      const lastDay = new Date(now.setDate(lastDayOfWeek));
      this.selectedDates = [firstDay, lastDay];
      this.fetchDashboardSummary(this.selectedDates);
    },

    onDateChange(selectedDates) {
      if (
        JSON.stringify(this.selectedDates) !== JSON.stringify(selectedDates)
      ) {
        this.selectedDates = selectedDates;
        this.fetchDashboardSummary(selectedDates);
      }
    },

    fetchDepartments() {
      this.$emit('loading', true);
      store
        .dispatch("dashboard/taskReport")
        .then((res) => {
          this.departmentOptions = res.data.departments;
          this.taskOptions = res.data.tasks || [];
          if (
            this.departmentOptions &&
            this.departmentOptions[0].children.length > 0
          ) {
            const deps = this.departmentOptions?.[0]?.children || [];

            this.selectedDepartments = [
              ...new Set(
                deps.flatMap(dep => [
                  dep.id,
                  ...(Array.isArray(dep.children)
                    ? dep.children.map(site => `${site.id}`)
                    : [])
                ])
              )
            ];
          }

          // Default select all task leaves if available
          if (this.taskOptions && this.taskOptions.length > 0) {
            const root = this.taskOptions[0];
            if (root && Array.isArray(root.children)) {
              this.selectedTasks = root.children.map(t => t.id);
            }
          }

          // If dates are already selected, refresh summary with new defaults
          if (this.selectedDates && this.selectedDates.length) {
            this.handleInput();
          }
          this.isLoading = false;
          this.$emit('loading', false);
        })
        .catch((error) => {
          this.$emit('loading', false);
          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },

    fetchDashboardSummary(selectedDates) {
      if (selectedDates.length !== 2) return; // Eğer iki tarih seçili değilse fonksiyonu çalıştırma

      let [startDate, endDate] = selectedDates;
      startDate = new Date(startDate).toISOString().split("T")[0];
      endDate = new Date(endDate).toISOString().split("T")[0];
      let departments = this.selectedDepartments;
      let selectedTasks = this.selectedTasks;

      this.isLoading = true;
      this.$emit('loading', true);
      store
        .dispatch("dashboard/dashboardSummary", {
          startDate,
          endDate,
          departments,
          selectedTasks,
        })
        .then((res) => {
          this.summary = res.data;

          this.taskTable = res.data.taskTable;
          this.renderCharts();
          // rebuild summary table if in summary mode
          if (this.isReportSummary) this.buildSummaryTable();
          if (this.isReportSummary) this.buildSummaryTable();
          this.isLoading = false;
          this.$emit('loading', false);
        })
        .catch((error) => {
          this.isLoading = false;
          this.$emit('loading', false);
          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },

    renderCharts() {
      this.renderTasksByDepartmentChart();
      // this.renderTasksBySiteChart();
      this.renderTaskCountsChart();
    },

    toggleSummary(){
      if (this.isReportSummary){
        this.buildSummaryTable();
      }
    },

    buildSummaryTable(){
      // summary.taskCounts already holds aggregated per task
      if (!this.summary || !Array.isArray(this.summary.taskCounts)){
        this.parsedSummaryReportTable = [];
        return;
      }
      // Ensure we treat total_minutes as a number (API should send integer minutes)
      const rows = this.summary.taskCounts.map(t => {
        const rawMinutes = Number(t.total_minutes) || 0;
        return {
          task_title: t.task,
          count: Number(t.count) || 0,
          total_minutes: this.convertMinutesToHoursMinutes(rawMinutes),
        };
      });
      // Mirror TaskReport: show total minutes as HH:MM regardless of report type
      let totalCount = rows.reduce((a,b)=> a + (Number(b.count)||0),0);
      let totalMinutesRaw = this.summary.taskCounts.reduce((a,b)=> {
        const val = Number(b.total_minutes);
        return a + (isNaN(val) ? 0 : val);
      },0);
      const totalMinutesDisplay = this.convertMinutesToHoursMinutes(totalMinutesRaw);
      rows.push({ task_title:'Total', count: totalCount, total_minutes: totalMinutesDisplay });
      this.parsedSummaryReportTable = rows;
    },

    renderTasksByDepartmentChart() {
  if (this.charts.tasksByDepartmentChart) {
    this.charts.tasksByDepartmentChart.destroy();
  }

  const ctx = document
    .getElementById("tasksByDepartmentChart")
    .getContext("2d");

  const labels = this.summary.activeDepartments.map(
    (dep) => dep.department
  );

  // Prepare datasets for stacked bar chart
  const siteNames = [];
  const siteDataMap = {};

  // Initialize siteDataMap with empty arrays
  this.summary.activeDepartments.forEach((dep) => {
    dep.sites.forEach((site) => {
      if (!siteNames.includes(site.site)) {
        siteNames.push(site.site);
        siteDataMap[site.site] = Array(
          this.summary.activeDepartments.length
        ).fill(0);
      }
    });
  });

  // Fill siteDataMap with actual values
  this.summary.activeDepartments.forEach((dep, depIndex) => {
    dep.sites.forEach((site) => {
      siteDataMap[site.site][depIndex] = this.selectedReport === 'Time Report' ? site.total_minutes : site.task_count;
    });
  });

  const datasets = siteNames.map((site, index) => ({
    label: site,
    data: siteDataMap[site],
    backgroundColor: this.colorPalette[index % this.colorPalette.length],
    borderColor: this.colorPalette[index % this.colorPalette.length],
    borderWidth: 1,
  }));

  this.charts.tasksByDepartmentChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels,
      datasets,
    },
    options: {
      responsive: false,
      scales: {
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
              callback: this.selectedReport === 'Time Report'
                ? function(value) {
                    const hours = Math.floor(value / 60);
                    const minutes = (value % 60).toString().padStart(2, "0");
                    return `${hours}:${minutes}`;
                  }
                : function(value) {
                    return value;
                  }, // No special formatting for Clinic Report
            },
          },
        ],
        xAxes: [
          {
            stacked: true,
          },
        ],
      },

      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
            if (this.selectedReport === 'Time Report') {
              const hours = Math.floor(value / 60);
              const minutes = value % 60;
              return `${hours}:${("0" + minutes).slice(-2)}`;
            } else {
              return value; // Display the count for Clinic Report
            }
          }.bind(this),
        },
      },
      legend: {
        display: true,
        position: 'right', // Move legend to the right side
   
      },
    },
  });
},
    renderTaskCountsChart() {
  if (this.charts.taskCountsChart) {
    this.charts.taskCountsChart.destroy();
  }

  const ctx = document.getElementById("taskCountsChart").getContext("2d");

  // Prepare datasets for the tasks chart
  const taskTitles = [];
  const taskDataMap = {};

  // Initialize taskDataMap with empty arrays
  this.summary.taskCounts.forEach(task => {
    if (!taskTitles.includes(task.task)) {
      taskTitles.push(task.task);
      taskDataMap[task.task] = Array(this.summary.taskCounts.length).fill(0);
    }
  });

  // Fill taskDataMap with actual values
  this.summary.taskCounts.forEach((task, index) => {
    taskDataMap[task.task][index] = this.selectedReport === 'Time Report' ? task.total_minutes : task.count;
  });

  const datasets = taskTitles.map((task, index) => ({
    label: task,
    data: taskDataMap[task],
    backgroundColor: this.colorPalette[index % this.colorPalette.length],
    borderColor: this.colorPalette[index % this.colorPalette.length],
    borderWidth: 1,
  }));

  this.charts.taskCountsChart = new Chart(ctx, {
    type: "bar",
    data: {
      labels: this.summary.taskCounts.map(task => task.task),
      datasets,
    },
    options: {
      responsive: false,
      scales: {
        xAxes: [
          {
            stacked: true,
          }
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              beginAtZero: true,
              callback: this.selectedReport === 'Time Report'
                ? function (value) {
                    const hours = Math.floor(value / 60);
                    const minutes = (value % 60).toString().padStart(2, "0");
                    return `${hours}:${minutes}`;
                  }
                :  function (value) {
                  
                    return value;
                  }, // No special formatting for Clinic Report
            },
          },
        ],
      },
 
      hover: {
        animationDuration: 0,
      },
   
      tooltips: {
        enabled: true,
        callbacks: {
          label: function (tooltipItem, data) {
            const value =
              data.datasets[tooltipItem.datasetIndex].data[
                tooltipItem.index
              ];
            if (this.selectedReport === 'Time Report') {
              const hours = Math.floor(value / 60);
              const minutes = value % 60;
              return `${hours}:${("0" + minutes).slice(-2)}`;
            } else {
              return value; // Display the count for Clinic Report
            }
          }.bind(this), // Bind `this` to access the component's data
        },
      },
      legend: {
        display: true,
        position: 'right', // Move legend to the right side
        labels: {
          fontSize: 10, // Adjust the font size of legend items here
        },
   
      },
    },
  });
},
    renderTasksBySiteChart() {
      if (this.charts.tasksBySiteChart) {
        this.charts.tasksBySiteChart.destroy();
      }

      const ctx = document.getElementById("tasksBySiteChart").getContext("2d");
      const labels = this.summary.activeSites.map((site) => site.site);
      const data = this.summary.activeSites.map((site) => site.task_count);

      this.charts.tasksBySiteChart = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Tasks by Site",
              data,
              backgroundColor: "#66BB6A",
            },
          ],
        },
        options: {
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
          animation: {
            onComplete: function() {
              const ctx = this.chart.ctx;
              ctx.font = Chart.helpers.fontString(
                Chart.defaults.global.defaultFontSize,
                "normal",
                Chart.defaults.global.defaultFontFamily
              );
              ctx.textAlign = "center";
              ctx.textBaseline = "bottom";

              this.data.datasets.forEach((dataset, i) => {
                const meta = this.chart.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  const data = dataset.data[index];
                  ctx.fillText(data, bar._model.x, bar._model.y + 15);
                });
              });
            },
          },
          hover: {
            animationDuration: 0, // Hover sırasında animasyonu devre dışı bırak
          },
          tooltips: {
            enabled: true, // Tooltips devre dışı bırak
          },

          legend: {
            display: true, // Legend'i gizle
          },
        },
      });
    },

    selectThisWeek() {
      const now = new Date();
      const firstDayOfWeek = now.getDate() - now.getDay() + 1; // Monday
      const lastDayOfWeek = firstDayOfWeek + 6; // Sunday
      const dates = [
        new Date(now.setDate(firstDayOfWeek)),
        new Date(now.setDate(lastDayOfWeek)),
      ];
      this.selectedDates = dates;
      this.fetchDashboardSummary(dates);
    },

    selectThisMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth(), 1),
        new Date(now.getFullYear(), now.getMonth() + 1, 0),
      ];
      this.selectedDates = dates;
      this.fetchDashboardSummary(dates);
    },

    selectLastMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth() - 1, 1),
        new Date(now.getFullYear(), now.getMonth(), 0),
      ];
      this.selectedDates = dates;
      this.fetchDashboardSummary(dates);
    },

    selectNextMonth() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), now.getMonth() + 1, 1),
        new Date(now.getFullYear(), now.getMonth() + 2, 0),
      ];
      this.selectedDates = dates;
      this.fetchDashboardSummary(dates);
    },

    selectThisYear() {
      const now = new Date();
      const dates = [
        new Date(now.getFullYear(), 0, 1),
        new Date(now.getFullYear(), 11, 31),
      ];
      this.selectedDates = dates;
      this.fetchDashboardSummary(dates);
    },

    convertMinutesToHoursMinutes(minutes) {
      // Be defensive: coerce, clamp, and round to avoid exponential or string artifacts
      let m = Number(minutes);
      if (!Number.isFinite(m) || m < 0) m = 0;
      const total = Math.round(m);
      const hours = Math.floor(total / 60);
      const remainingMinutes = total % 60;
      return `${hours}:${remainingMinutes.toString().padStart(2, "0")}`;
    },

    downloadPDF() {
      let dates = null;
      if (
        typeof this.selectedDates === "string" &&
        this.selectedDates.includes(" to ")
      ) {
        const [startDateStr, endDateStr] = this.selectedDates.split(" to ");

        const startDate = this.parseDate(startDateStr);
        const endDate = this.parseDate(endDateStr);

        dates = [startDate, endDate];
      } else {
        dates = this.selectedDates;
      }
      const departmentAnalysisTable = this.summary.activeDepartments
  .map((department) => {
    return department.sites.map((site) => {
      site.converted_total_minutes = this.convertMinutesToHoursMinutes(site.total_minutes);
      site.department = department.department; // Assuming department.department holds the department name or object
      return site;
    });
  })
  .flat();

// Calculate the total task_count and total_minutes (in minutes)
const totalTaskCount = departmentAnalysisTable.reduce((total, item) => total + item.task_count, 0);
const totalMinutes = departmentAnalysisTable.reduce((total, item) => {
  const [hours, minutes] = item.converted_total_minutes.split(':').map(Number);
  return total + (hours * 60) + minutes;
}, 0);

// Create the summary row
const summaryRow = {
  site: '',
  department: 'Total', // Leave empty or put a placeholder if necessary
  task_count: totalTaskCount,
  converted_total_minutes: this.convertMinutesToHoursMinutes(totalMinutes), // Convert total minutes to hours:minutes
};

departmentAnalysisTable.push(summaryRow);


const taskAnalysisTable = this.summary.taskCounts.map((task) => {
  task.converted_total_minutes = this.convertMinutesToHoursMinutes(task.total_minutes);
  return task;
});

const totalTaskAnalysisCount = taskAnalysisTable.reduce((total, item) => total + item.count, 0);
const totalAnalysisMinutes = taskAnalysisTable.reduce((total, item) => {
  const [hours, minutes] = item.converted_total_minutes.split(':').map(Number);
  return total + (hours * 60) + minutes;
}, 0);

// Create the summary row
const summaryAnalysisRow = {
  task: 'Total', // Leave empty or put a placeholder if necessary
  count: totalTaskAnalysisCount,
  converted_total_minutes: this.convertMinutesToHoursMinutes(totalAnalysisMinutes), // Convert total minutes to hours:minutes
};

taskAnalysisTable.push(summaryAnalysisRow);

      store
        .dispatch("dashboard/downloadPDF", {
          datePeriod:
            dates[0].toDateString() + " to " + dates[1].toDateString(),
          departments: this.departmentOptions
            .filter((e) => {
              return this.selectedDepartments.includes(e.id);
            })
            .map((e) => {
              return e.label;
            })
            .toString(),
          tasksCount: this.summary.activeTasks,
          departmentCount: this.summary.activeDepartments.length,
          siteCount: this.summary.activeSites.length,
          tasksByDepartmentBase64: document
            .getElementById("tasksByDepartmentChart")
            .toDataURL(),
          taskCountsBase64: document
            .getElementById("taskCountsChart")
            .toDataURL(),
          // tasksBySiteBase64: document.getElementById('tasksBySiteChart').toDataURL(),
          taskAnalysisTable: taskAnalysisTable,
          departmentAnalysisTable: departmentAnalysisTable,
          type:this.selectedReport,
       

            
          taskTable: this.taskTable,
        })
        .then((res) => {
          if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "dashboard-report.pdf");
            document.body.appendChild(link);
            link.click();

            this.$swal({
              title: "Succesfull!",
              text: "✔️ Report is created!",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching user report:", error);
        });
    },

    taskDataExport() {
      // Prepare export payload depending on summary toggle
      const exportData = this.isReportSummary
        ? this.parsedSummaryReportTable.map(item => ({
            task_name: item.task_title,
            department_name: "",
            site_name: "",
            total_task_count: item.count,
            total_minute_count: item.total_minutes,
          }))
        : this.taskTable;

      store
        .dispatch("dashboard/taskDataExport", { datas: exportData })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/octet-stream",
          });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.isReportSummary ? "rota_summary_report.xlsx" : "rota_report.xlsx");
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch((error) => {
          this.$swal({
            title: "Error!",
            text: "Report could not be loaded!" + error,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },
  },
};
</script>

<style scoped>
canvas {
  max-width: 100%;
}

.total-tasks-display h2 {
  font-size: 4em;
  color: #42a5f5;
  text-align: center;
}

.flat-pickr-wrapper {
  display: flex;
  align-items: center;
}

.flat-pickr-wrapper .form-control {
  margin-right: 1rem;
}

.flat-pickr-wrapper .d-flex {
  flex-wrap: wrap;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.85);
  z-index: 5;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
